// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1UWTq","radioRow":"SimpleQuestionBuilderModal_radioRow__36TJf"};